<template>
    <div>
        <div class="text-right">
            <b-button @click="cancel" variant="outline-primary" class="pl-4 pr-4">
                <i class="fa fa-undo mr-1"></i>
                {{myLabels[0]}}
            </b-button>
            <b-button @click="save" variant="primary" class="pl-4 pr-4 ml-1" >
                <i class="fa fa-floppy-o mr-1"></i>
                {{myLabels[1]}}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
  props: ["cancelLink", "labels"],
  data() {
    const { labels } = this;
    let myLabels = ["Cancel", "Save"];

    if (labels) myLabels = eval(labels);

    return { myLabels };
  },
  methods: {
    cancel() {
      if (this.cancelLink) {
        this.$router.push({ name: this.cancelLink });
      } else {
        this.$emit("cancel");  
      }
    },
    save() {
      this.$emit("save");
    }
  }
};
</script>